import { NgModule } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DividerModule } from 'primeng/divider';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputMaskModule } from 'primeng/inputmask';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';

@NgModule({
    declarations: [],
    imports: [
        OverlayPanelModule,
        ProgressSpinnerModule,
        PanelModule,
        DropdownModule,
        SelectButtonModule,
        SliderModule,
        ScrollPanelModule,
        DividerModule,
        InputSwitchModule,
        RadioButtonModule,
        InputMaskModule,
        FieldsetModule,
        InputTextModule,
        CalendarModule,
        TableModule,
        FileUploadModule,
        DialogModule,
    ],
    exports: [
        OverlayPanelModule,
        ProgressSpinnerModule,
        PanelModule,
        DropdownModule,
        SelectButtonModule,
        SliderModule,
        ScrollPanelModule,
        DividerModule,
        InputSwitchModule,
        RadioButtonModule,
        InputMaskModule,
        FieldsetModule,
        InputTextModule,
        CalendarModule,
        TableModule,
        FileUploadModule,
        DialogModule,
    ],
})
export class PrimeNgModule {}
